<template>
  <div class="finance-statements">
    <MoreTitle title="利润表" @click="goPage">
      <template v-slot:left>
        {{ $t('利润表') }}<span class="laste-report-icon">{{ lasteReportDate }}</span>
      </template>
    </MoreTitle>
    <div class="edge-padding">
      <RowInfo label="营业收入">{{ $digitjs(financeData.operatingIncome ?? financeData.revenue).convert() }}</RowInfo>
      <RowInfo label="营业收入同比">{{
        $digitjs(financeData.operatingIncomeYoY ?? financeData.revenueYoY)
          .unit('%')
          .rounded()
      }}</RowInfo>
      <RowInfo label="营业利润">{{ $digitjs(financeData[formatA('operatingProfit')]).convert() }}</RowInfo>
      <RowInfo label="营业利润同比">{{
        $digitjs(financeData[formatA('operatingProfitYoY')]).unit('%').rounded()
      }}</RowInfo>
      <RowInfo label="净利润">{{ $digitjs(financeData.netProfit ?? financeData.profitAfterTax).convert() }}</RowInfo>
      <RowInfo label="净利润同比">{{
        $digitjs(financeData.netProfitYoY ?? financeData.profitAfterTaxYoY)
          .unit('%')
          .rounded()
      }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  props: ['reportTypeMap'],
  data() {
    return {
      financeData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    lasteReportDate() {
      const { reportType, endDate, balanceSheetDate } = this.financeData
      const year = this.$dayjs(endDate).format('YYYY')
      const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
      const sortYear = isBefore ? +year + 1 : +year
      return endDate && reportType
        ? `(${this.$t('$x年', {
            x: sortYear
          })}${this.$t(this.reportTypeMap[reportType])})`
        : ''
    }
  },
  created() {
    this.getFinanceData()
  },
  methods: {
    // A股字段特判
    formatA(val) {
      return this.market !== 'hs' ? val : val.replace('operatingProfit', 'operProfit')
    },
    async getFinanceData() {
      const search = this.getSearchInfo()
      const res = await this.$post(search.api, search.params)
      this.financeData = res.data?.[0] ?? {}
    },
    getSearchInfo() {
      const searchInfo = {
        hk: {
          api: this.$api.f10.hk + '/finance/income',
          params: {
            symbol: this.symbol
          }
        },
        hs: {
          api: this.$api.f10.hs + '/finance/income',
          params: {
            symbol: this.symbol
          }
        },
        us: {
          api: this.$api.f10.us + '/finance/income-basic',
          params: {
            symbol: this.symbol,
            reportTypes: ['Q1', 'Q6', 'Q9', 'FY'],
            reportSize: 1
          }
        }
      }
      return searchInfo[this.market]
    },
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.symbol,
          type: 'income'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
